<template lang="html">

    <div>
        <table class="table is-fullwidth is-bordered">
            <tbody>
                <tr v-for="obj in data.objects" :key="obj.name">

                    <!-- CREATE -->
                    <td v-if="obj.create_fields">
                        <label class="label">
                            <input type="radio" :name="obj.name" value="create" v-model="selected_choices[obj.name]" @change="saveRecord(obj, obj.newField, obj.create_fields)" :disabled="!obj.create_fields || !obj.existing_fields"/>
                            Create New {{ obj.label }}
                        </label>
                        <div v-for="field in obj.create_fields" class="py-1">
                            <bulmaField :id="field.name" :data="getField(field, obj)" :disabledProp="!selected_choices[obj.name] || selected_choices[obj.name] != 'create'" @saveNewRecord="saveRecord(obj, obj.newField, obj.create_fields)"></bulmaField>
                        </div>
                        <p v-if="obj.optional" class="">
                            <input type="radio" :name="obj.name" value="dontCreate" v-model="selected_choices[obj.name]" @change="saveRecord(obj, obj.newField, obj.create_fields, true)"/>
                            Don't create {{ obj.label }} upon conversion
                        </p>
                    </td>

                    <!-- EXISTING -->
                    <td v-if="obj.existing_fields">
                        <label class="label">
                            <input type="radio" :name="obj.name" value="existing" v-model="selected_choices[obj.name]" @change="saveRecord(obj, obj.newField, obj.existing_fields)" :disabled="!obj.create_fields || !obj.existing_fields"/>
                            Choose Existing {{ obj.label }}
                        </label>
                        <div v-for="field in obj.existing_fields" class="py-1">
                            <bulmaField :id="field.name" :data="getField(field, obj)" :disabledProp="!selected_choices[obj.name] || selected_choices[obj.name] != 'existing'"></bulmaField>
                            <bulmaTable v-if="field.hintTable" :id="field.hintTable" :saveInRecord="true" :disabledProp="!selected_choices[obj.name] || selected_choices[obj.name] != 'existing'" @click="table()"></bulmaTable>
                        </div>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>
  
</template>
  
<script>

export default {
    name: 'bulmaConversion',
    components: {},
    props: {},
    data: function () {
        return {
            selected_choices: {}
        }
    },
    watch: {
        '$store.getters.getRecordData': function(newVal, oldVal) {
            console.log('watcher getRecordData', newVal, oldVal)
            // console.log(newVal.Id, oldVal.Id)
            // if((newVal && !oldVal) || (oldVal && newVal.Id != oldVal.Id)) this.loadRows()
        },
        convertHintValues(newVal, oldVal) {
            console.log('watcher convertHintValues', newVal, oldVal)
            for(var f of Object.keys(newVal)) {
                if(newVal[f])this.$store.commit('SET_FIELD_VALUE', { fieldname: f, fieldvalue: newVal[f] } );
            }
        },
    },
    computed: {
        id() {
            let process = this.$store.getters.getProcess(this.$store.state.global_state_process)
            let verb = this.$store.getters.getVerb( process, 'c' )
            console.log('VERB',verb)
            return verb.pageid
        },
        data() {
            return this.$store.getters.getObject(this.id).data
        },
        convertHintValues() {
            var last = this.$store.state.last_convertHint
            var tmp = {}
            for(var o of this.$store.state.convertHint.values()) {
                for(var f of o.values()) {
                    tmp[f.field] = f.value
                }
            }
            return tmp
        }
    },
    mounted: function() {
        this.$store.commit('CLEAR_CONVERT_INFO')
        this.$store.commit('CLEAR_CONVERT_SELECTEDCHOICES')
        this.$store.commit('SET_RECORDS_STATE', { id: this.$store.getters.getProcessStatus.processId, state: 'EDIT' })

        for(var obj of this.data.objects) {
            this.$set(this.selected_choices, obj.name, 'create')
            this.$store.commit('SET_CONVERT_SELECTEDCHOICES', { field: obj.name, value: 'create' })
            this.saveRecord(obj, obj.newField, obj.create_fields)
            if(obj.existing_fields) {
                for(var ex of obj.existing_fields) {
                    if(ex.hintTable) {
                        console.log(ex)
                        this.$store.commit('SET_CONVERT_HINT', { id: ex.hintTable, type: 'id', field: ex.name, value: '' })
                        this.$store.commit('SET_CONVERT_HINT', { id: ex.hintTable, type: 'related', field: ex.related, value: '' })
                    }
                }
            } 
        }
    },
    methods: {
        getField (field, obj) {
            if(field.type == 'picklist') {
                if (!this.$store.state.database.has(obj.table)) {
                    field.type = 'text'
                    return { ...field, "convertLead": true }
                }

                let table=this.$store.state.database.get(obj.table);
                if (table.has(field.newField)) {
                    let f2={ ...table.get(field.newField) }
                    f2.name = field.name
                    return { ...f2, "convertLead": true }
                }
            }
            return { ...field, "convertLead": true }
        },
        saveRecord(obj, recordField, fields, optional) {
            console.log('-> saveRecord')
            if(!optional) {
                var value = {}
                for(var f of fields) {
                    if(this.$store.getters.getRecordData[f.name]) {
                        if(f.newField) value[f.newField] = this.$store.getters.getRecordData[f.name] 
                        else value[f.name] = this.$store.getters.getRecordData[f.name] 
                    } else  value[f.newField] = f.default
                }
                if(this.selected_choices[obj.name] == 'create') {
                    // value.SalesPaddy_Owner__c = this.$store.state.myprofile.contactId
                    value.SalesPaddy_Creator__c = this.$store.state.myprofile.contactId
                }
                this.$store.commit('SET_CONVERT_INFO', { field: recordField, value: JSON.stringify(value) })
                
            } else this.$store.commit('SET_CONVERT_INFO', { field: recordField, value: '{}' })
            
            if(obj.dependency && obj.dependency.length > 0) this.setDependencies(obj)

            this.$store.commit('SET_CONVERT_SELECTEDCHOICES', { field: obj.name, value: this.selected_choices[obj.name] })
            this.$store.dispatch('checkRequiredFields')
        },
        setDependencies(obj) {
            obj.dependency.forEach( d => {
                console.log('d',d)
                let info = this.data.objects.find( o => o.name == d )

                if(this.selected_choices[d]) {
                    var choice = this.selected_choices[obj.name]

                    if(choice == 'existing' && !info.existing_fields) choice = 'create'

                    this.selected_choices[d] = choice
                    this.$store.commit('SET_CONVERT_SELECTEDCHOICES', { field: d, value: this.selected_choices[d] })
                }

                console.log('this.selected_choices[d]',this.selected_choices[d])
                switch(this.selected_choices[d]) {
                    case 'create':
                        if(info.create_fields) this.saveRecord(d, info.newField, info.create_fields)
                        else console.log('Missing create_fields in object '+obj.name)
                        break
                    case 'existing':
                        if(info.existing_fields) this.saveRecord(d, info.newField, info.existing_fields)
                        else console.log('Missing existing_fields in object '+obj.name)
                        break
                    case 'dontCreate':
                        this.$store.commit('SET_CONVERT_INFO', { field: info.newField, value: '{}' })
                }

            })
        }
    }
}
</script>

<style>
.pe-none {
    pointer-events: none;
}
/* .table td, .table th {
    border: 0
} */
</style>
  